import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { logoutUser, notifyAuthChanged } from "../../auth";

const navItems = [
  { id: "candidate-dashboard", label: "Dashboard", icon: "la la-home", key: "dashboard", to: "/candidate-dashboard" },
  { id: "candidate-profile", label: "My Profile", icon: "la la-user-tie", key: "profile", to: "/candidate-profile" },
  { id: "candidate-view-profile", label: "View Profile", icon: "la la-user-alt", key: "view-profile", to: "/candidate-view-profile" },
  { id: "candidate-applied", label: "Applied Jobs", icon: "la la-briefcase", key: "applied", to: "/candidate-applied-jobs" },
  { id: "candidate-shortlisted", label: "Shortlisted Jobs", icon: "la la-bookmark-o", key: "shortlisted", to: "/candidate-shortlisted-jobs" },
  { id: "candidate-alerts", label: "Job Alerts", icon: "la la-bell", key: "alerts", to: "/candidate-job-alerts" },
  { id: "candidate-logout", label: "Logout", icon: "la la-sign-out", to: "/" },
];

const CandidateSidebar = ({ active = "dashboard", onClose }) => {
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logoutUser({ notify: false });
    onClose?.();
    navigate("/login", { replace: true });
    notifyAuthChanged();
  };

  return (
    <div className="user-sidebar">
      <div className="sidebar-inner">
        <div className="candidate-sidebar-head">
          <div>
            <h4>Candidate Menu</h4>
            <span>Manage your job search</span>
          </div>
          <button type="button" onClick={onClose} aria-label="Close candidate menu">
            &times;
          </button>
        </div>

        <ul className="navigation">
          {navItems.map((item) => (
            <li className={item.key === active ? "active" : ""} key={item.id}>
              <Link to={item.to || "/candidate-dashboard"} onClick={item.id === "candidate-logout" ? handleLogout : onClose}>
                <i className={item.icon}></i>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="candidate-sidebar-note">
          <h4>Quick Tip</h4>
          <p>Keep your profile updated so employers can understand your skills faster.</p>
        </div>
      </div>
    </div>
  );
};

export default CandidateSidebar;
